/* import __COLOCATED_TEMPLATE__ from './list-item.hbs'; */
import type User from 'volta/models/user';
import templateOnlyComponent from '@ember/component/template-only';

interface UserListItemSignature {
  Args: {
    isSelected?: boolean;
    option: User;
  };
}

const UserListItemComponent = templateOnlyComponent<UserListItemSignature>();

export default UserListItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'User::ListItem': typeof UserListItemComponent;
    'user/list-item': typeof UserListItemComponent;
  }
}
